import { CreateRoleSchema, ScopeConfig, UpdateRoleSchema } from '@app/models/users';

import { IFormValues } from '../interfaces';

const getPermissions = (formValues: IFormValues, config: ScopeConfig[]) =>
  config.map((scopeConfig) => ({
    permission_scope: scopeConfig.scope,
    rules: scopeConfig.actions.map((actionConfig) => ({
      action: actionConfig.action,
      level: formValues[scopeConfig.scope]?.[actionConfig.action],
    })),
  }));

export const getPOSTRequestDataFromFormValues = (
  formValues: IFormValues,
  config: ScopeConfig[]
): CreateRoleSchema | UpdateRoleSchema => ({
  name: formValues.newRoleName || '',
  permissions: getPermissions(formValues, config),
});

export const getPUTRequestDataFromFormValues = (
  formValues: IFormValues,
  config: ScopeConfig[]
): CreateRoleSchema | UpdateRoleSchema => ({
  name: formValues.name || '',
  permissions: getPermissions(formValues, config),
});
